import { useState } from "react";
import { Avatar } from "../../../components/Avatar";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Logo } from "../../../components/Logo";
import { Navbar } from "../../../components/Navbar";
import { SegmentedControl } from "../../../components/SegmentedControl";
import { SideNav } from "../../../components/SideNav";
import { Tabs } from "../../../components/Tabs";
import { Section } from "../DesignSystem";

const block: React.CSSProperties = { marginBottom: "var(--space-8)" };

export const NavigationSection = () => {
  const [tab, setTab] = useState("cameras");
  const [layout, setLayout] = useState("grid");
  const [range, setRange] = useState("24h");

  return (
    <Section label="11 · Components" title="Navigation">
      <div style={block}>
        <Navbar
          brand={<Logo />}
          sectionLabel="CENTRAL SQUARE MARKET"
          rightActions={
            <>
              <span>Docs</span>
              <span>Support</span>
            </>
          }
          avatar={<Avatar name="Faria Azim" size="md" />}
        />
      </div>

      <div style={block}>
        <Breadcrumb
          items={[{ label: "Your stores", href: "/stores" }, { label: "Central Square Market" }]}
        />
      </div>

      <div style={block}>
        <Tabs
          value={tab}
          onChange={setTab}
          items={[
            { value: "cameras", label: "Cameras", count: 14 },
            { value: "nvrs", label: "NVRs", count: 2 },
            { value: "members", label: "Members", count: 3 },
            { value: "events", label: "Events" },
            { value: "settings", label: "Settings" },
          ]}
        />
      </div>

      <div style={{ ...block, display: "flex", gap: "var(--space-6)" }}>
        <SegmentedControl
          aria-label="Layout"
          value={layout}
          onChange={setLayout}
          options={[
            { value: "grid", label: "Grid" },
            { value: "rows", label: "Rows" },
          ]}
        />
        <SegmentedControl
          aria-label="Time range"
          value={range}
          onChange={setRange}
          options={[
            { value: "1h", label: "1h" },
            { value: "24h", label: "24h" },
            { value: "7d", label: "7d" },
          ]}
        />
      </div>

      <div style={{ ...block, maxWidth: 240 }}>
        <SideNav
          ariaLabel="Settings"
          items={[
            { label: "Store", href: "/" },
            { label: "NVRs & cameras", href: "/nvrs" },
            { label: "Members", href: "/members" },
            { label: "AI instructions", href: "/ai" },
            { label: "Danger zone", href: "/danger" },
          ]}
        />
      </div>
    </Section>
  );
};
